import { api } from "./client";

interface ApprovalOptions {
  approvalToken?: string;
}

export function getPharmacy() {
  return api.get("/pharmacy");
}

export function getPharmacySettings() {
  return api.get("/pharmacy/settings");
}

export function updatePharmacyInfo(
  data: Record<string, unknown>,
  options?: ApprovalOptions
) {
  return api.put("/pharmacy/update-info", data, {
    headers: options?.approvalToken
      ? { Authorization: `Bearer ${options.approvalToken}` }
      : undefined,
  });
}

export function updatePharmacyDetails(
  data: Record<string, unknown>,
  options?: ApprovalOptions
) {
  return api.put("/pharmacy/update-details", data, {
    headers: options?.approvalToken
      ? { Authorization: `Bearer ${options.approvalToken}` }
      : undefined,
  });
}

export interface PharmacyOptions {
  confirm_stock_on_dispense: boolean;
  confirm_stock_scope: "cii_only" | "all";
  require_patient_on_dispense: boolean;
}

export function getPharmacyOptions(): Promise<{
  success: boolean;
  data: PharmacyOptions;
}> {
  return api.get("/pharmacy/options");
}

export function updatePharmacyOptions(
  data: Partial<PharmacyOptions>
): Promise<{ success: boolean; message: string }> {
  return api.patch("/pharmacy/options", data);
}
